import { render, staticRenderFns } from "./ReportList.vue?vue&type=template&id=32a238e7&scoped=true&"
import script from "./ReportList.vue?vue&type=script&lang=js&"
export * from "./ReportList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a238e7",
  null
  
)

export default component.exports